<template>
  <v-form ref="basketAddForm" @submit.prevent="submitType()">
    <v-row justify="start" align="end">
      <v-col cols="12" md="12" sm="12" class="py-0">
        <v-btn-toggle
          active-class="active-select"
          v-model="qty_type"
          color="blue darken-2"
          group
          :mandatory="!isBasketItem"
          style="width: 100%"
          @change="qtyTypeChangeSubmit()"
        >
          <v-layout
            row
            justify-start
            align-start
            style="width: 100%; margin: 0"
          >
            <v-flex xs4 v-if="boxPriceDisplay.amount > 0">
              <v-btn
                value="B"
                v-if="boxPriceDisplay.amount > 0"
                :disabled="isReadOnly"
                class="pa-0"
                outlined
                style="border-color: #00000014; text-transform: capitalize"
              >
                <v-layout row wrap justify-start align-start>
                  <v-flex xs12 class="pa-0">{{ boxUnitOfSale }}</v-flex>
                  <v-flex>
                    <template v-if="retrieveShowPrices">
                      <span style="color: var(--v-color_off-base)">£</span>
                      <span style="font-weight: bold">{{
                        boxPriceDisplay.amount_display
                      }}</span>
                    </template>
                  </v-flex>
                </v-layout>
              </v-btn>
            </v-flex>
            <v-flex xs4 v-if="kiloPriceDisplay.amount > 0">
              <v-btn
                value="K"
                v-if="kiloPriceDisplay.amount > 0"
                :disabled="isReadOnly"
                class="pa-0"
                outlined
                style="border-color: #00000014; text-transform: capitalize"
              >
                <v-layout row wrap justify-start align-start>
                  <v-flex xs12 class="pa-0">Kilo</v-flex>
                  <v-flex>
                    <template v-if="retrieveShowPrices">
                      <span style="color: var(--v-color_off-base)">£</span>
                      <span style="font-weight: bold">{{
                        kiloPriceDisplay.amount_display
                      }}</span>
                    </template>
                  </v-flex>
                </v-layout>
              </v-btn>
            </v-flex>
            <v-flex xs4 v-if="eachPriceDisplay.amount > 0">
              <v-btn
                value="E"
                v-if="eachPriceDisplay.amount > 0"
                class="pa-0"
                outlined
                :disabled="isReadOnly"
                style="border-color: #00000014; text-transform: capitalize"
              >
                <v-layout row wrap justify-start align-start>
                  <v-flex xs12 class="pa-0">{{ eachUnitOfSale }}</v-flex>
                  <v-flex>

                  <template v-if="retrieveShowPrices">
                    <span style="color: var(--v-color_off-base)">£</span>
                    <span style="font-weight: bold">{{
                      eachPriceDisplay.amount_display
                    }}</span>
                    </template>
                  </v-flex>
                </v-layout>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-btn-toggle>
      </v-col>
      <v-col cols="12" md="12" sm="12" class="py-0">
        <v-layout style="width: 100%; margin: 0">
          <v-flex>
            <v-text-field
              v-model="qty"
              type="number"
              @focus="$event.target.select()"
              color="blue darken-2"
              :label="$vuetify.breakpoint.mdAndUp ? 'Quantity' : 'Qty'"
              dense
              :hint="maxValueHint"
              :rules="[rules.qtyRules(qty, qty_type, product)]"
              :disabled="
                (!isBasketItem && !product.available_for_sale) ||
                retrieveGuest ||
                isReadOnly
              "
              outlined
              prepend-icon="mdi-minus"
              @click:prepend="decreaseQtyField"
              append-outer-icon="mdi-plus"
              @click:append-outer="increaseQtyField"
              class="centered-input"
            ></v-text-field>
          </v-flex>
          <v-flex style="display: flex; align-items: start">
            <v-btn
              v-if="!isBasketItem"
              :disabled="
                (!product.qty_type && !product.available_for_sale) ||
                retrieveGuest ||
                isReadOnly
              "
              color="blue darken-2"
              outlined
              class="px-0"
              :loading="loadingSubmit"
              @click="submitType"
              style="height: 40px"
              >Add</v-btn
            >
            <v-btn
              v-else
              :disabled="
                (!isBasketItem && !product.available_for_sale) ||
                retrieveGuest ||
                isReadOnly
              "
              color="deep-purple base"
              outlined
              class="px-0"
              :loading="loadingSubmit"
              @click="amendType"
              style="height: 40px"
              >Update</v-btn
            >
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},

  props: {
    isBasketItem: Boolean,
    product: {},
    isStandingOrder: Boolean,
    isReadOnly: Boolean,
  },

  data() {
    return {
      qty: 1,
      qty_type: "E",
      loadingSubmit: false,

      rules: {
        qtyRules(qty, qty_type, product) {
          //We must have a value
          if (!qty || qty <= 0) {
            return "Invalid Qty";
          }

          //Number must be an Int APART FROM IF KILO

          if (qty_type != "K") {
            if (!Number.isInteger(parseFloat(qty))) {
              return "Must be an Integer";
            }
          } else {
            var regex = new RegExp("^[0-9]+(.[0-9]{1,2})?$", "g");

            if (!regex.test(qty)) {
              return "Must be 2 DP";
            }
          }

          //Qty Max
          switch (qty_type) {
            case "B":
              if (qty > product.box_max) {
                return "Max Qty: " + product.box_max;
              }
              break;
            case "K":
              if (qty > product.kilo_max) {
                return "Max Qty: " + product.kilo_max;
              }
              break;
            case "E":
              if (qty > product.each_max) {
                return "Max Qty: " + product.each_max;
              }
              break;
          }

          return true;
        },
      },
    };
  },

  beforeMount() {
    this.validateInputs();
  },

  watch: {
    product: function (newVal) {
      if (newVal != undefined) {
        this.validateInputs();
      } else {
        console.log("-- Undefined Product");
        console.log("  -- Look for it here?");
      }
    },
  },

  computed: {
    ...mapGetters(["retrieveGuest", "retrieveShowPrices"]),

    boxUnitOfSale() {
      let unit = "Box";

      if (this.product.unit_of_sale) {
        if (/\S/.test(this.product.unit_of_sale)) {
          unit = this.product.unit_of_sale;
        }
      }

      return unit;
    },

    eachUnitOfSale() {
      let unit = "Each";

      if (this.product.each_unit_of_sale) {
        if (/\S/.test(this.product.each_unit_of_sale)) {
          unit = this.product.each_unit_of_sale;
        }
      }

      return unit;
    },

    boxPriceDisplay() {
      if (parseInt(this.product.catch_weight_flag) == 1) {
        return {
          amount: 0,
          amount_display: 0,
        };
      } else {
        return {
          amount: parseFloat(this.product.box_price).toFixed(2),
          amount_display: parseFloat(this.product.box_price).toFixed(2),
        };
      }
    },

    kiloPriceDisplay() {
      if (parseInt(this.product.catch_weight_flag) == 1) {
        return {
          amount: 0,
          amount_display: 0,
        };
      } else {
        return {
          amount: parseFloat(this.product.kilo_price).toFixed(2),
          amount_display: parseFloat(this.product.kilo_price).toFixed(2),
        };
      }
    },

    eachPriceDisplay() {
      if (
        !this.$store.getters.retrieveIsCncCustomer &&
        !this.$store.getters.retrieveIsCashCustomer &&
        !this.$store.getters.retrieveIsPaymentWithOrderCustomer &&
        parseInt(this.product.catch_weight_flag) == 2
      ) {
        return {
          amount: parseFloat(this.product.kilo_price).toFixed(2),
          amount_display:
            parseFloat(this.product.kilo_price).toFixed(2) + "/kg",
        };
      } else if (
        !this.$store.getters.retrieveIsCncCustomer &&
        !this.$store.getters.retrieveIsCashCustomer &&
        !this.$store.getters.retrieveIsPaymentWithOrderCustomer &&
        parseInt(this.product.catch_weight_flag) == 1
      ) {
        return {
          amount: parseFloat(this.product.kilo_price).toFixed(2),
          amount_display:
            parseFloat(this.product.kilo_price).toFixed(2) + "/kg",
        };
      } else {
        return {
          amount: parseFloat(this.product.each_price).toFixed(2),
          amount_display: parseFloat(this.product.each_price).toFixed(2),
        };
      }
    },

    maxValueHint() {
      switch (this.qty_type) {
        case "B":
          if (
            this.product.box_max != 9999 &&
            this.product.box_max != undefined
          ) {
            return "Max Qty: " + this.product.box_max;
          }
          break;
        case "K":
          if (
            this.product.kilo_max != 9999 &&
            this.product.kilo_max != undefined
          ) {
            return "Max Qty: " + this.product.kilo_max;
          }
          break;
        case "E":
          if (
            this.product.each_max != 9999 &&
            this.product.each_max != undefined
          ) {
            return "Max Qty: " + this.product.each_max;
          }
          break;
      }

      return "";
    },
  },
  methods: {
    ...mapActions([
      "setSnackbar",
      "getTrollys",
      "getTemplates",
      "getStandingOrderTrolly",
    ]),

    increaseQtyField() {
      console.log("Qty ++");
      this.qty++;
    },

    decreaseQtyField() {
      console.log("Qty --");
      this.qty--;
    },

    submitType() {
      if (this.isBasketItem) {
        this.amend();
      } else if (this.isStandingOrder) {
        this.submitStanding();
      } else {
        this.submit();
      }
    },
    amendType() {
      if (this.isBasketItem && this.isStandingOrder) {
        this.amendStanding();
      } else {
        this.amend();
      }
    },

    qtyTypeChangeSubmit() {
      if (this.isBasketItem) {
        if (this.isStandingOrder) {
          this.amendStanding();
        } else {
          this.amend();
        }
      }
    },

    validateInputs() {
      if (this.isBasketItem) {
        if (!this.product.qty) {
          this.qty = 1;
        } else {
          this.qty = parseFloat(parseFloat(this.product.qty).toFixed(2));
        }
      } else {
        this.qty = 1;
      }

      if (this.isBasketItem) {
        this.qty_type = this.product.qty_type;
        return;
      } else {
        if (parseFloat(this.product.each_price) > 0) {
          this.qty_type = "E";
          return;
        } else if (parseFloat(this.product.kilo_price) > 0) {
          this.qty_type = "K";
          return;
        } else if (parseFloat(this.product.box_price) > 0) {
          this.qty_type = "B";
          return;
        }
      }
    },

    async submit() {
      if (this.$refs.basketAddForm.validate()) {
        this.loadingSubmit = true;

        let stringPayload = JSON.stringify({
          sessionKey: this.$store.getters.retrieveUser.sessionKey,
          userId: this.$store.getters.retrieveUser.userNum,
          trollyId: this.$store.getters.retrieveCurrentTrolly.id,
          prodNo: this.product.prod_no,
          qtyType: this.qty_type,
          qty: this.qty,
          comment: this.comment,
          br: 0,
        });

        const params = new URLSearchParams();
        params.append("params", stringPayload);

        let response = await axios
          .post("put-trolly-item", params)
          .catch((err) => {
            console.log(err);
          });

        if (response.data.success) {
          this.setSnackbar({ text: "Item added to basket" });

          this.getTrollys()
            .then((response) => {
              console.log("-- Got Trollys");
              console.log(response);

              this.$router.push({ name: "OrdersSearch" }).catch((e) => {
                console.log(e);
              });
            })
            .catch((er) => {
              console.log(er);
            });
        } else {
          this.setSnackbar({
            color: "error",
            text: "Error adding item to basket",
          });
        }

        this.$emit("closeDialog");

        this.loadingSubmit = false;
      }
    },

    async submitTemplate() {
      if (this.$refs.basketAddForm.validate()) {
        this.loadingSubmit = true;

        let stringPayload = JSON.stringify({
          sessionKey: this.$store.getters.retrieveUser.sessionKey,
          userId: this.$store.getters.retrieveUser.userNum,
          trollyId: this.$store.getters.retrieveCurrentTemplate.id,
          prodNo: this.product.prod_no,
          qtyType: this.qty_type,
          qty: this.qty,
          comment: this.comment,
          br: 0,
        });

        const params = new URLSearchParams();
        params.append("params", stringPayload);

        let response = await axios
          .post("put-trolly-item", params)
          .catch((err) => {
            console.log(err);
          });

        if (response.data.success) {
          this.setSnackbar({ text: "Item added to template" });
          this.getTemplates();
        } else {
          this.setSnackbar({
            color: "error",
            text: "Error adding item to template",
          });
        }

        this.loadingSubmit = false;
      }
    },

    async submitStanding() {
      if (this.$refs.basketAddForm.validate()) {
        this.loadingSubmit = true;

        let stringPayload = JSON.stringify({
          sessionKey: this.$store.getters.retrieveUser.sessionKey,
          userId: this.$store.getters.retrieveUser.userNum,
          trollyId: this.$store.getters.retrieveCurrentStandingOrder.trolly_id,
          prodNo: this.product.prod_no,
          qtyType: this.qty_type,
          qty: this.qty,
          comment: this.comment,
          br: 0,
        });

        const params = new URLSearchParams();
        params.append("params", stringPayload);

        let response = await axios
          .post("put-trolly-item", params)
          .catch((err) => {
            console.log(err);
          });

        if (response.data.success) {
          this.setSnackbar({ text: "Item added to standing order" });
          this.getStandingOrderTrolly();
        } else {
          this.setSnackbar({
            color: "error",
            text: "Error adding item to standing order",
          });
        }
        this.loadingSubmit = false;
      }
    },

    async amend() {
      if (this.$refs.basketAddForm.validate()) {
        console.log("Amend");
        console.log(this.qty);
        console.log(this.qty_type);

        this.loadingSubmit = true;

        let stringPayload = JSON.stringify({
          sessionKey: this.$store.getters.retrieveUser.sessionKey,
          userId: this.$store.getters.retrieveUser.userNum,
          trollyId: this.$store.getters.retrieveCurrentTrolly.id,
          trollyItemId: this.product.id,
          prodNo: this.product.prod_no,
          qtyType: this.qty_type,
          qty: this.qty,
          comment: this.comment,
          br: 0,
        });

        const params = new URLSearchParams();
        params.append("params", stringPayload);

        await axios
          .post("put-trolly-item", params)
          .then((response) => {
            if (response.data.success) {
              this.setSnackbar({
                text: "Item Updated (" + this.product.id + ")",
              });
              this.refreshBasket();
            } else {
              this.setSnackbar({
                color: "error",
                text: "Error adding item to basket",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });

        this.loadingSubmit = false;
      }
    },

    async refreshBasket() {
      console.log("-- Refresh Basket");
      await this.getTrollys()
        .then((response) => {
          console.log("-- Got Trollys");
          console.log(response);
        })
        .catch((er) => {
          console.log(er);
        });
    },

    async amendStanding() {
      if (this.$refs.basketAddForm.validate()) {
        console.log("Amend");
        console.log(this.qty);
        console.log(this.qty_type);

        this.loadingSubmit = true;

        let stringPayload = JSON.stringify({
          sessionKey: this.$store.getters.retrieveUser.sessionKey,
          userId: this.$store.getters.retrieveUser.userNum,
          trollyId: this.$store.getters.retrieveStandingOrderTrolly.id,
          trollyItemId: this.product.id,
          prodNo: this.product.prod_no,
          qtyType: this.qty_type,
          qty: this.qty,
          comment: this.comment,
          br: 0,
        });

        const params = new URLSearchParams();
        params.append("params", stringPayload);

        await axios
          .post("put-trolly-item", params)
          .then((response) => {
            if (response.data.success) {
              this.setSnackbar({
                text: "Item Updated (" + this.product.id + ")",
              });
              this.getStandingOrderTrolly();
            } else {
              this.setSnackbar({
                color: "error",
                text: "Error Updating Item",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });

        this.loadingSubmit = false;
      }
    },
  },
};
</script>

<style lang="sass">
.active-select
  border-color: #f57c00 !important

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button
  -webkit-appearance: none

input[type=number]
  -moz-appearance: textfield

.centered-input input
  text-align: center !important
</style>